import { render, staticRenderFns } from "./Article1DesktopDefault.vue?vue&type=template&id=dddb5be4&scoped=true&"
import script from "./Article1DesktopDefault.vue?vue&type=script&lang=js&"
export * from "./Article1DesktopDefault.vue?vue&type=script&lang=js&"
import style0 from "./Article1DesktopDefault.vue?vue&type=style&index=0&id=dddb5be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddb5be4",
  null
  
)

export default component.exports